// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"cdd790e68fecc02d6f03","873":"19a586b8bff0b719a351"}[chunkId] + ".js";
};